module.exports = new __parcel__URL__("apple_en.f4eee0f9.jpeg").toString();